import { render, staticRenderFns } from "./applyReturn.vue?vue&type=template&id=7671fa46&scoped=true&"
import script from "./applyReturn.vue?vue&type=script&lang=js&"
export * from "./applyReturn.vue?vue&type=script&lang=js&"
import style0 from "./applyReturn.vue?vue&type=style&index=0&id=7671fa46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671fa46",
  null
  
)

export default component.exports